// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"112":"build-glob","220":"build-doc","839":"build-map"}[chunkId] + "-legacy." + {"112":"b39eafda","220":"5f1b2b5c","839":"ec503faf"}[chunkId] + ".js";
};